import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Paintbrush } from 'lucide-react';

interface WidgetCustomizerProps {
  widgetSize: 'compact' | 'standard' | 'detailed';
  setWidgetSize: (v: 'compact' | 'standard' | 'detailed') => void;
  colorTheme: 'brand' | 'orange';
  setColorTheme: (v: 'brand' | 'orange') => void;
  language: 'it' | 'en' | 'de' | 'fr';
  setLanguage: (v: 'it' | 'en' | 'de' | 'fr') => void;
}

export function WidgetCustomizer({ widgetSize, setWidgetSize, colorTheme, setColorTheme, language, setLanguage }: WidgetCustomizerProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-l flex items-center gap-2">
          <Paintbrush className="w-5 h-5" />
          Personalizza il widget
        </CardTitle>
        <CardDescription>
          Scegli dimensione e lingua del widget prima di integrarlo nei tuoi canali digitali.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <label className="text-s">Dimensione Widget</label>
          <Select value={widgetSize} onValueChange={(v: any) => setWidgetSize(v)}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="compact">Compatto (280x120px)</SelectItem>
              <SelectItem value="standard">Standard (350x180px)</SelectItem>
              <SelectItem value="detailed">Dettagliato (420x240px)</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-ss text-muted-foreground">Scegli il formato piu adatto allo spazio sul sito.</p>
        </div>

       {/*  <div className="space-y-2">
          <label className="text-s">Colore Tema</label>
          <Select value={colorTheme} onValueChange={(v: any) => setColorTheme(v)}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="brand">Brand Travelin</SelectItem>
              <SelectItem value="orange">Arancione Travelin</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-ss text-muted-foreground">Scegli uno stile coerente con la tua identita visiva.</p>
        </div> */}

        <div className="space-y-2">
          <label className="text-s">Lingua</label>
          <Select value={language} onValueChange={(v: any) => setLanguage(v)}>
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="it">Italiano</SelectItem>
              <SelectItem value="en">Inglese</SelectItem>
              <SelectItem value="de">Tedesco</SelectItem>
              <SelectItem value="fr">Francese</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-ss text-muted-foreground">Imposta la lingua mostrata ai visitatori.</p>
        </div>
      </CardContent>
    </Card>
  );
}
